import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { KYMW1708Model } from "../kymw1708.model";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 複数コード画像情報登録
 * 
 */
@Injectable()
export class RegistMultipleCodeImageInfoService extends PlessJsonResponderSub<any> {
  model: KYMW1708Model;
  successFunc: Function;
  
  /**
   * bodyにセットする値を返す
   * 
   */
  getBody() {
    return new PlessRequest({
      update: {
        PastImage: {
          condition: {
            ImageId: this.model.imageId,
            CallerImageId: this.model.callerImageId,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   * 
   * @param model 
   * @param success 
   */
  execute(model: KYMW1708Model, success: Function = null) {
    this.model = model;
    this.successFunc = success;
    this.send('registMultipleCodeImageInfo', this.getBody());
  }

  /**
   * API成功後処理
   * @param data 
   */
  success(data: any): void {
    if (this.successFunc) this.successFunc();
  }
}